module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "senspro"
  }, [_c('el-form', {
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "label-width": "20px",
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p"
  }, [_vm._v("企业周边500M人口：")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.form.surround500m),
      callback: function($$v) {
        _vm.$set(_vm.form, "surround500m", $$v)
      },
      expression: "form.surround500m"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1,
      "disabled": ""
    }
  }, [_vm._v("<500")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2,
      "disabled": ""
    }
  }, [_vm._v("500-1000")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3,
      "disabled": ""
    }
  }, [_vm._v(">1000")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p"
  }, [_vm._v("企业周边5KM人口：")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.form.surround5km),
      callback: function($$v) {
        _vm.$set(_vm.form, "surround5km", $$v)
      },
      expression: "form.surround5km"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1,
      "disabled": ""
    }
  }, [_vm._v("<1万")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2,
      "disabled": ""
    }
  }, [_vm._v("1万-5万")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3,
      "disabled": ""
    }
  }, [_vm._v(">5万")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "arr_b",
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p"
  }, [_vm._v("企业雨水排口、清净下水排口、污水排口下游10km存在的环境风险受体（多选）：")]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.checkList),
      callback: function($$v) {
        _vm.checkList = $$v
      },
      expression: "checkList"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "1"
    }
  }, [_vm._v("乡镇及以上城镇饮用水水源（地表水或地下水）保护区")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "2"
    }
  }, [_vm._v("自来水厂取水口")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "3"
    }
  }, [_vm._v("水源涵养区")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "4"
    }
  }, [_vm._v("自然保护区")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "5"
    }
  }, [_vm._v("重要湿地")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "6"
    }
  }, [_vm._v("珍稀濒危野生动植物天然集中分布区")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "7"
    }
  }, [_vm._v("重要水生生物的自然产卵场及索饵场、越冬场和洄游通道")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "8"
    }
  }, [_vm._v("风景名胜区")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "9"
    }
  }, [_vm._v("特殊生态系统")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "10"
    }
  }, [_vm._v("世界文化和自然遗产地")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "11"
    }
  }, [_vm._v("红树林、珊瑚礁等滨海湿地生态系统")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "12"
    }
  }, [_vm._v("珍稀、濒危海洋生物的天然集中分布区")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "13"
    }
  }, [_vm._v("海洋特别保护区")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "14"
    }
  }, [_vm._v("海上自然保护区")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "15"
    }
  }, [_vm._v("盐场保护区")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "16"
    }
  }, [_vm._v("海水浴场")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "17"
    }
  }, [_vm._v("海洋自然历史遗迹")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "18"
    }
  }, [_vm._v("水产养殖区")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "19"
    }
  }, [_vm._v("天然渔场")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "20"
    }
  }, [_vm._v("耕地、基本农田保护区")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "21"
    }
  }, [_vm._v("富营养化水域")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "22"
    }
  }, [_vm._v("基本草原")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "23"
    }
  }, [_vm._v("森林公园")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "24"
    }
  }, [_vm._v("地质公园")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "25"
    }
  }, [_vm._v("天然林")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "26"
    }
  }, [_vm._v("海滨风景游览区")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "27"
    }
  }, [_vm._v("具有重要经济价值的海洋生物生存区域")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "28",
      "disabled": ""
    }
  }, [_vm._v("以上都没有")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "arr_bs",
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p"
  }, [_vm._v("24小时流经范围（单选）：")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.form.throughRange24h),
      callback: function($$v) {
        _vm.$set(_vm.form, "throughRange24h", $$v)
      },
      expression: "form.throughRange24h"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1,
      "disabled": ""
    }
  }, [_vm._v("以企业雨水排口（含泄洪渠）、清净下水排口、废水总排口算起，排水进入受纳河流最 大流速时，24小时流经范围内涉跨国界或省界的；")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2,
      "disabled": ""
    }
  }, [_vm._v("24小时流经范围内不涉跨国界或省界")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p"
  }, [_vm._v("影响半径(千米)："), _c('span', [_vm._v(_vm._s(_vm.form.affectRadius))])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d2d1bc4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/digtization/Sensprotection.vue
// module id = 1173
// module chunks = 2